export default __webpack_public_path__ + "images/bb08a7b14e1514368c2aabfc3c84f682-halloweenhaunt.webp";